export enum MimeType {
  // PDF mime-type
  APPLICATION_PDF = 'application/pdf',

  // Code mime-types
  TEXT_HTML = 'text/html',
  APPLICATION_JSON = 'application/json',
  APPLICATION_X_JAVASCRIPT = 'application/x-javascript',

  // Text mime-types
  TEXT_PLAIN = 'text/plain',
  APPLICATION_RTF = 'application/rtf',
  TEXT_RICHTEXT = 'text/richtext',

  // Archive mime-types
  APPLICATION_X_GZIP = 'application/x-gzip',
  APPLICATION_GZIP = 'application/gzip',
  APPLICATION_X_COMPRESSED = 'application/x-compressed',
  APPLICATION_X_ZIP_COMPRESSED = 'application/x-zip-compressed',
  APPLICATION_ZIP = 'application/zip',
  APPLICATION_X_TAR = 'application/x-tar',
  APPLICATION_JAVA_ARCHIVE = 'application/java-archive',
  MULTIPART_X_ZIP = 'multipart/x-zip',
  MULTIPART_X_GZIP = 'multipart/x-gzip',

  // MSWord mime-types
  APPLICATION_MSWORD = 'application/msword',
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE = 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12 = 'application/vnd.ms-word.document.macroEnabled.12',
  APPLICATION_VND_MS_WORD_TEMPLATE_MACROENABLED_12 = 'application/vnd.ms-word.template.macroEnabled.12',

  // Excel mime-types
  APPLICATION_MSEXCEL = 'application/msexcel',
  APPLICATION_VND_MS_EXCEL = 'application/vnd.ms-excel',
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12 = 'application/vnd.ms-excel.sheet.macroEnabled.12',
  APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12 = 'application/vnd.ms-excel.template.macroEnabled.12',
  APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12 = 'application/vnd.ms-excel.addin.macroEnabled.12',
  APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12 = 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',

  // Powerpoint mime-types
  APPLICATION_MSPOWERPOINT = 'application/mspowerpoint',
  APPLICATION_VND_MS_POWERPOINT = 'application/vnd.ms-powerpoint',
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE = 'application/vnd.openxmlformats-officedocument.presentationml.template',
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW = 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12 = 'application/vnd.ms-powerpoint.addin.macroEnabled.12',
  APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12 = 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12 = 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',

  // Image mime-types
  IMAGE_PNG = 'image/png',
  IMAGE_JPG = 'image/jpg',
  IMAGE_JPEG = 'image/jpeg',
  IMAGE_SVG_XML = 'image/svg+xml',
  IMAGE_GIF = 'image/gif',

  // Video mime-types
  APPLICATION_ANNODEX = 'application/annodex',
  APPLICATION_MP4 = 'application/mp4',
  APPLICATION_OGG = 'application/ogg',
  APPLICATION_OCTET_STREAM = 'application/octet-stream',
  APPLICATION_VND_RN_REALMEDIA = 'application/vnd.rn-realmedia',
  APPLICATION_X_MATROSKA = 'application/x-matroska',
  APPLICATION_X_TROFF_MSVIDEO = 'application/x-troff-msvideo',
  VIDEO_QUICKTIME = 'video/quicktime',
  VIDEO_MP4 = 'video/mp4',

  // Audio mime-types
  AUDIO_X_WAV = 'audio/x-wav',
  AUDIO_MPEG = 'audio/mpeg', // MimeType for MP3 extension.
  AUDIO_OGG = 'audio/ogg',
  AUDIO_WAV = 'audio/wav',
  AUDIO_VND_WAVE = 'audio/vnd.wave'
}

export const allMimeTypes: MimeType[] = Object.values(MimeType);
